"use client";

import React from "react";
import { Button, Sheets } from "@pamperedchef/design-system";

import * as styles from "./AddToCartSlider.module.scss";

export interface AddToCartSliderProps {
	isOpen: boolean;
	onClose: () => void;
	onViewCartAndCheckout: () => void;
	onContinueShopping: () => void;
	footer?: React.ReactNode;
	children?: React.ReactNode;
}

export function AddToCartSlider({
	isOpen,
	onClose,
	onViewCartAndCheckout,
	onContinueShopping,
	footer,
	children
}: AddToCartSliderProps): JSX.Element {
	return (
		<Sheets
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) onClose();
			}}
			onClose={onClose}
			onClosePress={onClose}
			title="Item Added to Cart"
			closeButtonLabel="Close added to cart"
			mobileVariant="fullscreen"
			className={styles.sheet}
		>
			<div className={styles.shell}>
				<div className={styles.body}>{children}</div>
				<footer className={styles.footer}>
					{footer}
					<Button
						kind="primary"
						size="lg"
						onPress={onViewCartAndCheckout}
						className={styles.primaryButton}
					>
						View Cart & Checkout
					</Button>
					<Button
						kind="secondary"
						size="lg"
						onPress={onContinueShopping}
						className={styles.secondaryButton}
					>
						Continue Shopping
					</Button>
				</footer>
			</div>
		</Sheets>
	);
}
